import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import Page from 'components/Page';
import EntityListPageSkeleton from 'components/OrderListPageSkeleton';
import OrderList from 'components/OrderList';
import TableSorting from 'components/TableSorting';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import { withData } from 'lib/relay';
import { OrderListPageQuery } from '__generated__/OrderListPageQuery.graphql';

const query = graphql`
  query OrderListPageQuery(
    $first: Int!
    $after: String
    $sort: OrdersSorting
    $search: String
  ) {
    ...OrderList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<OrderListPageQuery>;
};

const breadcrumps = [{ name: 'Užsakymai' }];

const OrderListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<OrderListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={breadcrumps}>
      <TableSorting>
        <Pagination>
          <Search>
            <OrderList data={data} />
          </Search>
        </Pagination>
      </TableSorting>
    </Page>
  );
};

export default withData<OrderListPageQuery>({
  query,
  reloadOnRender: false,
  loading: <EntityListPageSkeleton breadcrumbs={breadcrumps} cols={8} />,
  variables: ({ currentUser }) => ({
    first: currentUser.itemsPerPage,
  }),
})(OrderListPage);
